import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { listarTabelasPreco, excluirTabelaPreco } from "../services/api";
import { Edit, Plus, Trash2 } from "lucide-react";

const ListaTabelasPreco = ({ token }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const resp = await listarTabelasPreco(token);
      setItems(Array.isArray(resp?.data) ? resp.data : []);
    } catch (e) {
      console.error(e);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [token]);

  const sorted = useMemo(
    () => [...items].sort((a, b) => (a.nome || "").localeCompare(b.nome || "")),
    [items]
  );

  const handleDelete = async (id, nome) => {
    if (!window.confirm(`Excluir a tabela "${nome}"?`)) return;
    try {
      await excluirTabelaPreco(id, token);
      await load();
    } catch (err) {
      const msg = err?.response?.data;
      alert(typeof msg === "string" ? msg : "Não foi possível excluir a tabela.");
    }
  };

  return (
    <div className="zen-card rounded-2xl p-6 shadow-sm dark:backdrop-blur">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Tabelas de preço</h2>
          <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">
            Defina preços por módulo e vincule às revendas.
          </p>
        </div>
        <Link
          to="/tabelas-preco/novo"
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-blue-600 text-white text-sm font-semibold hover:bg-blue-500"
        >
          <Plus size={18} />
          Nova tabela
        </Link>
      </div>

      {loading ? (
        <p className="text-gray-500 dark:text-slate-400">Carregando...</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-gray-500 dark:text-slate-400 border-b border-gray-100 dark:border-white/10">
                <th className="py-3 pr-4">Nome</th>
                <th className="py-3 pr-4">Itens</th>
                <th className="py-3 pr-4">Dono</th>
                <th className="py-3 pr-4">Status</th>
                <th className="py-3 text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              {sorted.map((t) => (
                <tr key={t.id} className="border-b border-gray-50 dark:border-white/5">
                  <td className="py-3 pr-4 font-medium text-gray-900 dark:text-white">{t.nome}</td>
                  <td className="py-3 pr-4 text-gray-600 dark:text-slate-300">{t.qtdItens ?? 0}</td>
                  <td className="py-3 pr-4 text-gray-600 dark:text-slate-300">
                    {t.distribuidorId ? "Distribuidor" : "Zen"}
                  </td>
                  <td className="py-3 pr-4">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${t.ativo ? "bg-green-100 text-green-800 dark:bg-green-500/20 dark:text-green-300" : "bg-gray-100 text-gray-600 dark:bg-white/10 dark:text-slate-400"}`}>
                      {t.ativo ? "Ativa" : "Inativa"}
                    </span>
                  </td>
                  <td className="py-3 text-right">
                    <div className="inline-flex gap-1">
                      <Link
                        to={`/tabelas-preco/editar/${t.id}`}
                        className="p-2 rounded-lg text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-500/10"
                        title="Editar"
                      >
                        <Edit size={16} />
                      </Link>
                      <button
                        type="button"
                        onClick={() => handleDelete(t.id, t.nome)}
                        className="p-2 rounded-lg text-red-600 hover:bg-red-50 dark:hover:bg-red-500/10"
                        title="Excluir"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {sorted.length === 0 && (
                <tr>
                  <td colSpan={5} className="py-10 text-center text-gray-500 dark:text-slate-400">
                    Nenhuma tabela cadastrada.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ListaTabelasPreco;
